import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Button,
} from '@mui/material'
import { Formik } from 'formik'
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import SupplierDetailsReport from '../Components/SupplierDetailReportFile'
import xlsx from 'json-as-xlsx';
import DoctorDetailsReport from './DoctorDetailsReport';
import ItemDetailsReport from './ItemDetailsReport';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function ItemDetailReport() {
    const [pageTitle, setPageTitle] = useState('Item Details Report');
    const [itemList, setItemList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - itemList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        GetItemDetails();
    }, [])

    function GetItemDetails() {
        axios.get('https://serverfourpaws.ccsoftwares.com/Item/getAllActiveItemDetails').then((res) => {
            if (res.data.length > 0) {
                setItemList(res.data);
                //console.log("res::> ", res.data)
            } else {
                toast.error("No records to display!");
            }
        })
    }

    async function createFile() {
        var file = await createDataFromExcel(itemList);
        var settings = {
            sheetName: 'Item Detail Report',
            fileName: 'Item Detail Report',
            writeOptions: {}
        }

        let tempcsvHeaders = csvHeaders;
        tempcsvHeaders.push({ label: 'ITem ID', value: 'ItemID' })
        tempcsvHeaders.push({ label: 'Doctor Name', value: 'ItemName' })
        tempcsvHeaders.push({ label: 'ContactNo', value: 'CategoryName' })
        tempcsvHeaders.push({ label: 'Role', value: 'ItemTypeID' })
        tempcsvHeaders.push({ label: 'Role', value: 'SellingPrice' })

    }

    async function createDataFromExcel(itemArray) {
        var result = [];
        if (itemArray != null) {
            itemArray.forEach(x => {
                result.push({
                    ItemID: x.ItemID,
                    ItemName: x.ItemName,
                    CategoryName: x.CategoryName,
                    ItemTypeID: x.ItemTypeID === 1 ? "Liquid" : x.ItemTypeID === 2 ? "Pills" : "Others",
                    SellingPrice: parseFloat(x.sellingPrice)
                });
            }
            );
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    {titleName}
                </Grid>

            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} >
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    {itemList.length > 0 ?
                                        <TableContainer>
                                            <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>#</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Name</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Category</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Type</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Selling Price</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? itemList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : itemList).map((row, index) => (
                                                            <TableRow key={row._id}>
                                                                <TableCell align='left'>{index + 1}</TableCell>
                                                                <TableCell align='left'>{row.ItemName}</TableCell>
                                                                <TableCell align='left'>{row.CategoryName}</TableCell>
                                                                <TableCell align='left'>{row.ItemTypeID === 1 ? "Liquid" : row.ItemTypeID === 2 ? "Pills" : "Others"}</TableCell>
                                                                <TableCell align='left'>{row.sellingPrice}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={5} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                            colSpan={5}
                                                            count={itemList.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            slotProps={{
                                                                select: {
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                },
                                                            }}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                            ActionsComponent={TablePaginationActions}
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                        : null}
                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                        <Button
                                            color="primary"
                                            id="btnRecord"
                                            variant="contained"
                                            style={{ marginRight: '1rem' }}
                                            onClick={createFile}
                                            size="small"
                                        >
                                            EXCEL
                                        </Button>
                                        <div>&nbsp;</div>
                                        <ReactToPrint
                                            documentTitle={'Item Details Report'}
                                            trigger={() => (
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    variant="contained"
                                                    size='small'
                                                >
                                                    PDF
                                                </Button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                        <div hidden={true}>
                                            <ItemDetailsReport
                                                ref={componentRef}
                                                itemList={itemList}
                                            />
                                        </div>
                                    </Box>
                                </Card>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Container>


        </>
    )
}

export default ItemDetailReport